import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-blog',
  imports: [RouterModule],
  templateUrl: './blog.component.html',
  styleUrl: './blog.component.css',
})
export class BlogComponent {
  posts = [
    { slug: 'prevision-marche', emoji: '📊', category: 'Stratégie', title: 'Comment prévoir ses ventes sur un marché', excerpt: 'Les clés pour estimer la demande avant chaque événement.' },
    { slug: 'meteo-ventes', emoji: '🌤️', category: 'Météo', title: 'Météo et ventes : le lien direct', excerpt: 'Comment la météo impacte vos ventes selon votre activité.' },
    { slug: 'retour-experience', emoji: '🥞', category: 'Témoignage', title: 'Expérience d\'un marchand de crêpes', excerpt: 'Retour d\'expérience sur ses 3 meilleurs marchés.' },
    { slug: 'gestion-stock', emoji: '📦', category: 'Gestion', title: 'Gestion des stocks pour marchands itinérants', excerpt: 'Optimiser ses approvisionnements pour réduire les pertes.' },
  ];
}